import { SearchResult } from 'lib/search/reducers';
import { SearchTerm } from '../types';

export const CLEAR_DATA = 'SEARCH/CLEAR_DATA';
export const CLEAR_RESULTS = 'SEARCH/CLEAR_RESULTS';
export const LOAD_DATA_CHUNK = 'SEARCH/LOAD_DATA_CHUNK';
export const UPDATE_SEARCH_ID = 'SEARCH/UPDATE_SEARCH_ID';
export const UPDATE_SEARCH_MATCHES = 'SEARCH/UPDATE_SEARCH_MATCHES';

export const ADD_SEARCH_TERM = 'SEARCH/ADD_TERM';
export const SET_SEARCH_TERMS = 'SEARCH/SET_TERMS';
export const REMOVE_SEARCH_TERM = 'SEARCH/REMOVE_TERM';
export const UPDATE_SEARCH_TERM = 'SEARCH/UPDATE_TERM';

export const SET_LOADING = 'SEARCH/LOADING';
export const LOAD_SEARCH_TERMS = 'SEARCH/LOAD_TERMS';

export function clearData() {
  return {
    type: CLEAR_DATA,
  };
}

export function loadDataChunk(artists: SearchResult[]) {
  return {
    type: LOAD_DATA_CHUNK,
    artists,
  };
}

export function addTerm(term: SearchTerm) {
  return { type: ADD_SEARCH_TERM, term };
}
export function setTerms(terms: SearchTerm[]) {
  return { type: SET_SEARCH_TERMS, terms };
}

export function updateTerm(termID: string, values: Partial<SearchTerm>) {
  return { type: UPDATE_SEARCH_TERM, values, termID };
}

export function removeTerm(termID: string) {
  return { type: REMOVE_SEARCH_TERM, termID };
}

export function setLoading(loading: boolean) {
  return { type: SET_LOADING, loading };
}
